// extracted by mini-css-extract-plugin
module.exports = {"wrap":"transactions_wrap__2fX4L","table":"transactions_table__2adGK","aside":"transactions_aside__2VAZ-"};